import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const segmentType = z.object({
    from: vector2Like,
    to: vector2Like,
    width: z.number(),
})

export const returnType = z.object({
    // referenceSegment: segmentType,
    // searchSegment: segmentType,
    correlationData: z.instanceof(Float32Array),
    peakIndex: vector2Like,
    peakValue: z.number(),
    bestMatchPosition: vector2Like,
})

export const definition = {
    validation: {
        returns: returnType,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            referenceSegment: segmentType,
            searchSegment: segmentType,
            stride: z._default(z.int().check(z.gte(1)), 1),
            penaltyFn: z.optional(z.custom<(point: z.infer<typeof vector2Like>) => number>((value) => typeof value === "function")),
        }),
    },
}
